









































import { Component, Vue, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import User from '@/models/user'



@Component
export default class Navigation extends Vue {
    @State public loggedIn: any
    @State('loggedInUser') user!: User

    @Prop({default: false}) authenticated!: boolean

    public expanded: boolean = false

    async logout() {
        this.$router.replace('/')
        await this.$auth.logout()
        this.$emit('logout')
    }

    goHome() {
        this.$router.push('/')
    }

}
